import { inject } from '@angular/core';
import { QarepaIntermediate } from '@qarepa/common';
import { OAuthStorageService } from '@qaroni-app/auth/services/o-auth-storage.service';

export class QaroniIntermediate extends QarepaIntermediate {
  protected override storage = inject(OAuthStorageService);
}
